import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useEffect, useState } from 'react';
const ThemeContext = createContext(undefined);
export function ThemeProvider({ children }) {
    const [theme, setTheme] = useState(() => {
        const saved = localStorage.getItem('app-theme');
        return saved || 'system';
    });
    const [resolvedTheme, setResolvedTheme] = useState('cool-light');
    useEffect(() => {
        localStorage.setItem('app-theme', theme);
        const doc = document.documentElement;
        const applyTheme = (t) => {
            doc.classList.remove('theme-light', 'theme-dark', 'theme-cool-light');
            doc.classList.add(`theme-${t}`);
            setResolvedTheme(t);
        };
        if (theme === 'system') {
            const isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
            applyTheme(isDark ? 'dark' : 'cool-light');
        }
        else {
            applyTheme(theme);
        }
    }, [theme]);
    useEffect(() => {
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        const handleChange = (e) => {
            if (theme === 'system') {
                const doc = document.documentElement;
                const newT = e.matches ? 'dark' : 'cool-light';
                doc.classList.remove('theme-light', 'theme-dark', 'theme-cool-light');
                doc.classList.add(`theme-${newT}`);
                setResolvedTheme(newT);
            }
        };
        mediaQuery.addEventListener('change', handleChange);
        return () => mediaQuery.removeEventListener('change', handleChange);
    }, [theme]);
    return (_jsx(ThemeContext.Provider, { value: { theme, setTheme, resolvedTheme }, children: children }));
}
export function useTheme() {
    const context = useContext(ThemeContext);
    if (context === undefined) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
}
